import type { CloudflareAsset } from "@/shared/common/enums";
import { CloudFlareImage } from "@/shared/components";
import { components } from "@ab.uitools/ui-library/components/ReactSelect";
import type {
  SingleValueProps,
  TOption
} from "@ab.uitools/ui-library/components/ReactSelect/types";

export const LanguageSelectSingleValue = (props: SingleValueProps<TOption>) => (
  <components.SingleValue {...props}>
    <CloudFlareImage className="language-icon" path={props.data.icon as CloudflareAsset}/>
  </components.SingleValue>
);
